// src/client/uiComponents.tsx
import {
  OrganizationProfile as BaseOrganizationProfile,
  SignIn as BaseSignIn,
  SignUp as BaseSignUp,
  UserProfile as BaseUserProfile
} from "@clerk/clerk-react";
import { useRoutingProps } from "@clerk/clerk-react/internal";
import React from "react";
import { usePathnameWithoutSplatRouteParams } from "./usePathnameWithoutSplatRouteParams.js";
var UserProfile = Object.assign(
  (props) => {
    const path = usePathnameWithoutSplatRouteParams();
    return /* @__PURE__ */ React.createElement(BaseUserProfile, { ...useRoutingProps("UserProfile", props, { path }) });
  },
  { ...BaseUserProfile }
);
var OrganizationProfile = Object.assign(
  (props) => {
    const path = usePathnameWithoutSplatRouteParams();
    return /* @__PURE__ */ React.createElement(BaseOrganizationProfile, { ...useRoutingProps("OrganizationProfile", props, { path }) });
  },
  { ...BaseOrganizationProfile }
);
var SignIn = (props) => {
  const path = usePathnameWithoutSplatRouteParams();
  return /* @__PURE__ */ React.createElement(BaseSignIn, { ...useRoutingProps("SignIn", props, { path }) });
};
var SignUp = (props) => {
  const path = usePathnameWithoutSplatRouteParams();
  return /* @__PURE__ */ React.createElement(BaseSignUp, { ...useRoutingProps("SignUp", props, { path }) });
};
export {
  OrganizationProfile,
  SignIn,
  SignUp,
  UserProfile
};
//# sourceMappingURL=uiComponents.js.map